import { Vue } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import UIkit from "uikit";
import { InstructionLevel, SelectableProfile, StatsApi, StatsItemEnum, UserStats } from "../../types";
import Store from "../../store";
export default class ChartViewMixin extends Vue {
  participantsMax?: number;
  participantsMin?: number;
  selectedUsers: SelectableProfile[] = [];
  memory: SelectableProfile[] = [];
  confirmationOperation?: string;
  targetStats!: StatsItemEnum | StatsItemEnum[];
  chartData?: UserStats;
  loadingFunction?: boolean = false;
  departmentUserSelectorFormKey = 0;
  tutorialImagePath?: string;

  @Ref("selectionModal") selectionModal!: HTMLElement;
  onTargetUserSelectionChange(selectedUsers: SelectableProfile[]) {
    this.selectedUsers = selectedUsers;
  }
  onAddButtonClick() {
    this.memory = this.selectedUsers;
    this.departmentUserSelectorFormKey = Date.now();
    if (this.selectionModal) {
      UIkit.modal(this.selectionModal).show();
    }
  }
  onCloseButtonClick() {
    this.selectedUsers = this.memory;
    if (this.selectionModal) {
      UIkit.modal(this.selectionModal).hide();
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  async onSelectionDone() {}
  /**
   * selectionModalで選択したユーザをもとにチャートデータを取得
   */
  async onSelectionDoneButtonClick() {
    await UIkit.modal(this.selectionModal).hide();
    const peopleIds = this.selectedUsers.map(selectedUser => selectedUser.id);
    if (this.participantsMin && peopleIds.length < this.participantsMin) {
      Store.getInstance().setInstructionContent(InstructionLevel.Alert, `${this.participantsMin}人以上選択してください`);
      this.confirmationOperation = "require_more";
      return;
    }
    if (this.participantsMax && peopleIds.length > this.participantsMax) {
      Store.getInstance().setInstructionContent(InstructionLevel.Alert, `${this.participantsMax}人までしか選択できません`);
      this.confirmationOperation = "require_more";
      return;
    }
    if (this.loadingFunction && peopleIds.length >= 15) Store.getInstance().setIsLoading(true);
    const responsePeople = await new StatsApi().getPeopleStats({
      peopleIds,
      statsItems: Array.isArray(this.targetStats) ? this.targetStats : [this.targetStats]
    });
    this.chartData = responsePeople.data as UserStats;
    const completedTestUsers = Object.keys(this.chartData);
    const notDisplayUsers: string[] = [];
    this.selectedUsers = Object.assign(
      this.selectedUsers.filter(r => {
        if (!completedTestUsers.includes(r.id)) {
          r.selected = false;
          notDisplayUsers.push(r.lastName.concat(" ", r.firstName, "さん"));
          return false;
        }
        return true;
      })
    );
    if (this.loadingFunction && peopleIds.length >= 15) Store.getInstance().setIsLoading(false);
    if (notDisplayUsers.length) {
      Store.getInstance().setInstructionContent(
        InstructionLevel.Alert,
        `以下の受検者は未受検又は計算中です。\n${notDisplayUsers.join("\n")}`,
        () => {
          if (this.participantsMin && completedTestUsers.length < this.participantsMin) {
            Store.getInstance().setInstructionContent(
              InstructionLevel.Alert,
              "未受検又は計算中のユーザーを除外した結果、表示可能人数を下回りました。"
            );
          } else {
            this.onSelectionDone();
          }
        }
      );
    } else {
      this.onSelectionDone();
    }
  }
  showTutorial() {
    const obj = this.tutorialImagePath;
    if (obj) {
      let image = new Image();
      image.onload = function() {
        window.open(obj, "Image", `width=${image.width * 0.7},height=${image.height * 0.7},resizable=1`);
      };
      image.src = obj;
    }
  }
}
